/** Delay before the first retry; every further one doubles it, up to `AUTO_RETRY_MAX_DELAY_MS`. */
export const AUTO_RETRY_BASE_DELAY_MS = 300;

/** Ceiling for the doubling delay. Retries never run out, so they settle into this interval. */
export const AUTO_RETRY_MAX_DELAY_MS = 30_000;

/**
 * Two windows, each one fetch timeout wide, so neither can drift from `FETCH_TIMEOUT_MS`.
 *
 * `AUTO_RETRY_GRACE_MS` is how long a failure stays hidden behind retries before it is shown to the
 * user, so an engine that does not answer surfaces in seconds rather than after several attempts
 * that each cost a full timeout. `AUTO_RETRY_RECOVERY_MS` is how long the query must stay healthy,
 * with no error and nothing in flight, before the backoff resets.
 */
export { FETCH_TIMEOUT_MS as AUTO_RETRY_GRACE_MS, FETCH_TIMEOUT_MS as AUTO_RETRY_RECOVERY_MS } from './fetch';
